import { FinalizarCompraTermos } from "./FinalizarCompraTermos";
import { FinalizarCompraResumo } from "./FinalizarCompraResumo";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { BuscarCautelasCarrinhoDto } from "@/dtos/Request/RequestBuscarCautelasCarrinho";
import { PresenteadoDto } from "@/services/AcessoService";
import { DrawerPagamentoParaOutraPessoa } from "./DrawerPagamentoParaOutraPessoa";

interface FinalizarCompraCartaoCreditoProps {
    dadosResumo: BuscarCautelasCarrinhoDto,
    formik: any,
    presenteados: PresenteadoDto[],
    handlePresenteados: (action: 'remove' | 'load', presenteado?: PresenteadoDto) => void,
}

export function FinalizarCompraCartaoCredito({ dadosResumo, formik: formikFormFinalizarCompraCartaoCredito, presenteados, handlePresenteados }: FinalizarCompraCartaoCreditoProps) {
    const [termosAceito, setTermosAceito] = useState(false);

    async function handleAceiarTermos(termos: boolean) {
        setTermosAceito(termos);
    }

    return (
        <div className="md:w-5/12">
            <div className="flex flex-col md:flex-row justify-between">
                <FinalizarCompraResumo dadosResumo={dadosResumo} />
            </div>

            <div className="flex flex-col gap-5">
                <DrawerPagamentoParaOutraPessoa handlePresenteados={handlePresenteados} presenteados={presenteados} />
                <FinalizarCompraTermos aceitarTermos={handleAceiarTermos} termosAceito={termosAceito} />
                <Button
                    className="w-full"
                    size="xl"
                    onClick={formikFormFinalizarCompraCartaoCredito.submitForm}
                    disabled={!formikFormFinalizarCompraCartaoCredito.isValid || !termosAceito || formikFormFinalizarCompraCartaoCredito.isSubmitting}
                    variant="default">
                    {
                        formikFormFinalizarCompraCartaoCredito.isSubmitting ? (<>Finalizando Compra...</>) : (<>Finalizar Compra</>)
                    }
                </Button>
            </div>
        </div>
    )
}